export default __webpack_public_path__ + "static/media/moderator-history-changes.8d1aaee2.svg";